<div class="container" *transloco="let t">
  <app-header [title]="t('ASSIGNMENT-PAGE.HEADER') + ' (' + audits().length + ')'" [withIcon]="true"></app-header>

  <div class="card-container">
    @if (audits().length > 0) {
      @for (audit of audits(); track audit.id) {
        <app-main-card [audit]="audit"></app-main-card>
      }
    } @else {
      <div class="empty-audit-list">
        <p class="subheadline-regular">{{ t('ASSIGNMENT-PAGE.SPACE-HOLDER') }}</p>
      </div>
    }
  </div>
</div>
